<template>
  <svg
    width="18"
    height="19"
    viewBox="0 0 18 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9 18.6504C4.02944 18.6504 0 14.621 0 9.65039C0 4.67983 4.02944 0.650391 9 0.650391C13.9706 0.650391 18 4.67983 18 9.65039C17.9945 14.6187 13.9683 18.6449 9 18.6504ZM9 12.3504C8.50294 12.3504 8.1 12.7533 8.1 13.2504V13.2504C8.1 13.7474 8.50294 14.1504 9 14.1504V14.1504C9.49706 14.1504 9.9 13.7474 9.9 13.2504V13.2504C9.9 12.7533 9.49706 12.3504 9 12.3504V12.3504ZM9 5.15039C8.50294 5.15039 8.1 5.55333 8.1 6.05039V9.65039C8.1 10.1474 8.50294 10.5504 9 10.5504V10.5504C9.49706 10.5504 9.9 10.1474 9.9 9.65039V6.05039C9.9 5.55334 9.49706 5.15039 9 5.15039V5.15039Z"
      fill="#FF726D"
    />
  </svg>
</template>

<script>
export default {
  name:  "GeneralErrorIcon"
};
</script>

<style></style>
